import { render, staticRenderFns } from "./FaceUp.vue?vue&type=template&id=80efeeca&"
import script from "./FaceUp.vue?vue&type=script&lang=js&"
export * from "./FaceUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports